
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSleetShowersNightColour as ObiSleetShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sleet-showers-night-colour.js';
 
 
 

 
 export const ObiSleetShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-sleet-showers-night-colour',
   elementClass: ObiSleetShowersNightColourElement,
   events: {
     
   }
  });
 
 